var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagequestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 15.3587H10.8332L7.12484 17.8254C6.99969 17.9088 6.85424 17.9567 6.704 17.9639C6.55377 17.9712 6.40439 17.9375 6.2718 17.8665C6.1392 17.7955 6.02837 17.6898 5.95112 17.5608C5.87387 17.4317 5.83311 17.2841 5.83317 17.1337V15.3587C3.33317 15.3587 1.6665 13.6921 1.6665 11.1921V6.19206C1.6665 3.69206 3.33317 2.02539 5.83317 2.02539H14.1665C16.6665 2.02539 18.3332 3.69206 18.3332 6.19206V11.1921C18.3332 13.6921 16.6665 15.3587 14.1665 15.3587Z",
    stroke: "#F57C23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.4668V9.2918C10 8.72513 10.35 8.42513 10.7 8.18346C11.0417 7.95013 11.3834 7.65013 11.3834 7.10013C11.3834 6.33346 10.7667 5.7168 10 5.7168C9.23337 5.7168 8.6167 6.33346 8.6167 7.10013M9.99587 11.4585H10.0042",
    stroke: "#F57C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagequestion);
export default __webpack_public_path__ + "static/media/messagequestion.75ec5aa9d182977f4e59dc896dbe85af.svg";
export { ForwardRef as ReactComponent };